import { apiRequest, ReturnTypeWithPagination, ShowroomLocation, timeAsSeconds } from "@alba-cars/common-modules";
import qs from "qs";

const SHOWROOM_LOCATIONS_ENDPOINT = "/showroom-locations";

export const getShowroomLocations = async (
  locale: "en" | "ar" | "ru" | "zh" = "en",
): Promise<ShowroomLocation[]> => {
  const queryString = qs.stringify(
    {
      locale,
      sortBy: "sortOrder",
      limit: 100,
    },
    {
      skipNulls: true,
    },
  );

  const response = await apiRequest<ReturnTypeWithPagination<ShowroomLocation[]>>(
    `${SHOWROOM_LOCATIONS_ENDPOINT}?${queryString}`,
    {
      headers: {
        "Accept-Language": locale,
      },
      next: {
        revalidate: timeAsSeconds({ hours: 1 }),
        tags: ["showroom-locations", locale],
      },
    },
  );

  const data = response.data as unknown;
  if (Array.isArray(data)) {
    return data;
  }

  if (data && typeof data === "object" && "result" in data && Array.isArray(data.result)) {
    return data.result as ShowroomLocation[];
  }

  return [];
};

export const getShowroomLocationOptions = async (
  locale: "en" | "ar" | "ru" | "zh" = "en",
): Promise<(ShowroomLocation & { label: string; value: string })[]> => {
  const showrooms = await getShowroomLocations(locale);

  return showrooms.map((showroom) => ({
    ...showroom,
    label: showroom.name,
    value: showroom.slug,
  }));
};
